module.exports = __webpack_public_path__ + "static/qrPaymentMobile_es-f6add7fa17885a28e32e28cd8cfd7e7d.svg";